import { createReducer } from "@reduxjs/toolkit";
import { ABOUT_ERROR, ABOUT_LOADING, ABOUT_LIST } from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const aboutUsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(ABOUT_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(ABOUT_ERROR, (state, { payload }) => {
      state.error = payload;
    })
    .addCase(ABOUT_LIST, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default aboutUsReducer;
